<template>
    <v-navigation-drawer
        ref="navDrawer"
        v-model="drawer.show"
        width="190"
        class="order-navigation-drawer"
        :mobile-breakpoint="600"
        :mini-variant="drawer.mini"
        :mini-variant-width="80"
        clipped
        app
    >
        <div class="drawer-content">
            <v-list class="menu-list">
                <div>
                    <v-list-item
                        v-if="!!curCashRegister"
                        id="shift-btn"
                        class="menu-item"
                        :disabled="!allows('allow_shifts') || !curCashRegister"
                        @click="showShift"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-calendar-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $t('general.shift') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="curShift && allows('allow_receipts')"
                        id="receipts-btn"
                        class="menu-item"
                        @click="showReceipts"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon v-if="!einvoiceOnly">fal fa-receipt</v-icon>
                            <v-icon v-else>fal fa-file-alt</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                <span v-if="!einvoiceOnly">{{ $tc('general.receipt', 2) }}</span>
                                <span v-else>{{ $tc('general.invoice', 2) }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="curShift"
                        id="staff-btn"
                        class="menu-item"
                        @click="showStaff"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-users</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $tc('general.staff', 2) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="allows('allow_cash_register') && !!curCashRegister && !curCashRegister.shared"
                        id="cash-register-btn"
                        class="menu-item"
                        @click="showCashRegister"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-cash-register</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $t('general.cash_register') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="!!curCashRegister && allows('allow_cash_register')"
                        id="reports-btn"
                        class="menu-item"
                        @click="showReports"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-file-chart-line</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $tc('general.report', 2) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="locale === 'sr' && !this.noncashOnly && device.platform !== 'web'"
                        id="sdc-management-btn"
                        class="menu-item"
                        @click="showSdcManagement"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-chart-network</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $t('general.sdc_short') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="allows('nav_access_admin')"
                        id="admin-btn"
                        class="menu-item"
                        @click="$router.push({ name: 'admin' }).catch(err => {})"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-sliders-h</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $t('general.administration') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>

                <div class="menu-item-additional">
                    <v-list-item
                        class="menu-item"
                        @click="reloadApp"
                    >
                        <v-list-item-icon class="menu-icon">
                            <v-icon>fal fa-redo</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="ml-3">
                                {{ $t('general.refresh_app') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>

            </v-list>
        </div>

        <!-- Shift Management -->
        <v-dialog
            v-model="show.shift"
            width="400"
            @keydown.esc="show.shift = false"
        >
            <div class="py-3 px-4 bg-white">
                <v-btn
                    class="h60 mb-3"
                    color="success"
                    block
                    large
                    :disabled="!!curShift || busy"
                    @click="openShift"
                >
                    {{ $t('general.open_shift') }}
                </v-btn>

                <v-btn
                    class="h60 mb-3"
                    color="error"
                    block
                    large
                    :disabled="!curShift || busy"
                    @click="initCloseShift()"
                >
                    {{ $t('general.close_shift') }}
                </v-btn>

                <v-btn
                    class="h60"
                    color="default"
                    block
                    large
                    @click="show.shift = false"
                >
                    {{ $t('general.cancel') }}
                </v-btn>
            </div>
        </v-dialog>

        <!-- Cash Register Management -->
        <cash-register-management
            :show.sync="show.cashRegister"
            :disabled="busy"
            @deposit="show.cashRegisterDeposit = true"
            @cash-out="show.cashRegisterCashOut = true"
        />

        <!-- Terminal Register -->
        <terminal-register
            :show.sync="show.terminal"
        />

        <!-- Reports -->
        <reports-dialog :show.sync="show.reports" />

        <!-- Staff Management -->
        <staff
            :show.sync="show.staff"
            @update-deposit="showUserDeposit($event)"
        />

        <!-- Receipts -->
        <receipts :show.sync="show.receipts" />

        <!-- Deposit Dialog -->
        <numpad-expanded
            :show.sync="show.deposit"
            type="userDeposit"
            :title="$t('general.deposit')"
            :value="0"
            :total="depositUser ? depositUser.getDeposit().toRoundedUnit(2) : 0"
            @confirm="updateUserDeposit($event.value)"
        />

        <!-- Cash Register Initial Deposit Dialog -->
        <numpad-expanded
            :show.sync="show.cashRegisterDeposit"
            type="cashRegisterDeposit"
            :title="$t('general.cash_register_add_deposit')"
            :value="0"
            :total="0"
            @confirm="addCashRegisterDeposit($event.value)"
        />

        <!-- Cash Register Cash Out Dialog -->
        <numpad-expanded
            :show.sync="show.cashRegisterCashOut"
            type="cashRegisterCashOut"
            :title="$t('general.cash_register_cash_out')"
            :value="0"
            :total="show.cashRegisterCashOut ? curCashRegisterCash : 0"
            :max="show.cashRegisterCashOut ? curCashRegisterCash : 0"
            @confirm="addCashRegisterTransaction(-1 * $event.value)"
        />

        <!-- SDC Management -->
        <sdc-management
            v-if="locale === 'sr' && !this.noncashOnly && device.platform !== 'web'"
            :show.sync="show.sdcManagement"
        />

    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import EinvoiceService from '@/services/EinvoiceService';

import User from '@/models/User';
import Shift from '@/models/Shift';
import Terminal from '@/models/Terminal';
import CashRegister from '@/models/CashRegister';
import Notification from '@/models/Notification';

import Staff from '@/views/shared/components/Staff';
import Receipts from '@/views/shared/components/Receipts';
import CashRegisterManagement from '@/views/shared/components/CashRegisterManagement';
import TerminalRegister from '@/views/shared/components/TerminalRegister';
import ReportsDialog from '@/views/shared/components/ReportsDialog';
import SdcManagement from '@/views/shared/components/SdcManagement';
import NumpadExpanded from '@/components/NumpadExpanded';

import * as mutationTypes from '@/store/mutationTypes';

export default {
    name: 'OrderNavigationDrawer',

    components: {
        Staff,
        CashRegisterManagement,
        TerminalRegister,
        ReportsDialog,
        SdcManagement,
        NumpadExpanded,
        Receipts
    },

    created() {
        this.eventBus.$on('order-toggle-drawer', this.toggleDrawer);
        this.eventBus.$on('order-toggle-shift', this.showShift);
        this.eventBus.$on('cash-register-deposit', this.showCashRegisterDeposit);
    },

    async mounted() {
        // activated
        if (this.$route.params.show) {
            this.show[this.$route.params.show] = true;
        }

        const terminal = await Terminal.current()

        if(!terminal) {
            this.show.terminal = true;
        } else if(this.curShift && moment.duration(moment().diff(moment(this.curShift.opened_at))).asHours() > 72) {
            this.$confirm(
                this.$t('order.error.shift_too_long_description'),
                {
                    buttonTrueText: this.$t('general.close_shift'),
                    buttonCancelText: null,
                    icon: null,
                    color: 'error',
                    title: this.$t('order.error.shift_too_long'),
                    persistent: true,
                },
                async result => {
                    const closeShiftSuccess = await this.closeShift(true);
                    if(closeShiftSuccess) {
                        await this.openShift();
                    }
                }
            );
        }
    },

    beforeDestroy() {
        this.eventBus.$off('order-toggle-drawer', this.toggleDrawer);
        this.eventBus.$off('order-toggle-shift', this.showShift);
        this.eventBus.$off('cash-register-deposit', this.showCashRegisterDeposit);
    },

    data() {
        return {
            busy: false,

            drawer: {
                show: !this.$vuetify.breakpoint.xsOnly,
                mini: this.$vuetify.breakpoint.smOnly,
            },

            show: {
                shift: false,
                staff: false,
                cashRegister: false,
                terminal: false,
                reports: false,
                receipts: false,
                cashRegisterDeposit: false,
                cashRegisterCashOut: false,
                deposit: false,
                sdcManagement: false
            },

            depositUser: null
        }
    },

    watch: {
        $route(to, from) {
            if (to.params.show) {
                this.show[to.params.show] = true;
            } else {
                this.show.shift = this.show.staff = false;
            }
        },

        curShift(val) {
            this.show.shift = this.show.staff = false;
        },

        drawer: {
            deep: true,
            handler(val) {
                this.eventBus.$emit('drawer-toggle', val)
            }
        },

        show: {
            deep: true,
            handler(val) {
                this.eventBus.$emit('show-screens', val)
            }
        },

        // show: {
        //     deep: true,
        //     handler(val) {
        //         this.eventBus.$emit('show-screens', val)

        //         let routeParam = null;
        //         Object.keys(val).forEach(item => {
        //             if (val[item]) {
        //                 routeParam = item;
        //             }
        //         });

        //         if (routeParam) {
        //             this.$router.push({ name: 'allegraOrder', params: { show: routeParam } });
        //         } else {
        //             this.$router.replace({ name: 'allegraOrder' });
        //         }
        //     }
        // },
    },

    computed: {
        ...mapGetters(['curOrder', 'pausedOrder']),

        curUser() {
            return User.find(this.user.id).$duplicate();
        },

        curShift() {
            return Shift.current();
        },

        curCashRegister() {
            return CashRegister.current();
        },

        curCashRegisterCash() {
            return this.curCashRegister ? this.curCashRegister.getCash().toRoundedUnit(2) : 0;
        },

        noncashOnly() {
            return this.tenant && this.tenant.venue && !!this.tenant.venue.settings.noncash_only
        },

        einvoiceOnly() {
            return EinvoiceService.einvoiceOnly();
        }
    },

    methods: {
        showCashRegisterDeposit() {
            this.show.cashRegisterDeposit = true
        },

        showShift() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.drawer.show = false
            }
            this.show.shift = this.allows('allow_shifts') && !this.show.shift
        },

        toggleDrawer() {
            if(this.$refs.navDrawer) {
                this.$refs.navDrawer.isActive = true
            }

            if(this.$vuetify.breakpoint.smAndUp) {
                this.drawer.mini = !this.drawer.mini;
                return
            }

            this.drawer.mini = false
            this.drawer.show = !this.drawer.show;
        },

        showReceipts() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.drawer.show = false
            }
            this.show.receipts = !this.show.receipts;
        },

        showCashRegister() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.drawer.show = false
            }
            this.show.cashRegister = this.allows('allow_cash_register') && !this.show.cashRegister
        },

        showReports() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.drawer.show = false
            }
            this.show.reports = this.allows('allow_cash_register') && !this.show.reports
        },

        showSdcManagement() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.drawer.show = false
            }
            this.show.sdcManagement = !this.show.sdcManagement
        },

        showStaff() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.drawer.show = false
            }
            this.show.staff = !this.show.staff;
        },

        async openShift() {
            this.busy = true

            const result = await Shift.open()

            this.busy = false

            if(!result.success) {
                this.$snackbar(result.error, 'error');
                return false;
            }

            if(this.curCashRegister.depositRequired()) {
                this.show.shift = false;
                this.show.cashRegisterDeposit = true;
            } else {
                this.$snackbar(this.$t('general.shift_opened'), 'success');
            }

            this.checkNotifications()

            return true;
        },

        async initCloseShift() {
            if(!this.canCloseShift()) {
                this.$snackbar(this.$t('allegra.order.close_shift_error'), 'error');
                return;
            }

            this.show.shift = false;

            const pausedOrderClear = new Promise((resolve, reject) => {
                this.$confirm(
                    this.$t('allegra.order.close_shift_paused_order'),
                    {
                        buttonTrueText: this.$t('general.yes'),
                        buttonFalseText: this.$t('general.no'),
                        icon: 'fal fa-times',
                        color: 'info',
                        title: this.$t('general.close_shift'),
                        persistent: true,
                    },
                    async result => {
                        resolve(result)
                    }
                );
            })

            if(this.pausedOrder) {
                const result = await pausedOrderClear
                if(!result) return;
                this.$store.commit(mutationTypes.SET_PAUSED_ORDER, { pausedOrder: null });
            }

            this.$confirm(
                this.$t('reports.shift_report_print_confirm'),
                {
                    buttonTrueText: this.$t('general.yes'),
                    buttonFalseText: this.$t('general.no'),
                    icon: 'fal fa-times',
                    color: 'info',
                    title: this.$t('reports.shift_report'),
                    persistent: true,
                },
                async result => {
                    if(result === null) return;

                    const curShiftOpenedAt = Shift.current().getOpenedAt().format('YYYY-MM-DD HH:mm:ss')
                    const shiftCloseResult = await this.closeShift();

                    if(result && shiftCloseResult) {
                        await this.printShiftReport(curShiftOpenedAt);
                    }
                }
            );
        },

        canCloseShift() {
            const usersDebtNotCleared = User.all().some(user => !user.getDebt().isZero());
            if (usersDebtNotCleared || (this.curOrder && this.curOrder.items.length)) return false;

            return true;
        },

        async closeShift(force = false) {
            this.busy = true

            const result = await Shift.close();

            this.busy = false

            if(!result.success) {
                this.$snackbar(result.error, 'error');
                return false;
            }

            if(!force) {
                this.$snackbar(this.$t('general.shift_closed'));
            }

            return true;
        },

        async printShiftReport(startTime) {
            const curCashRegister = CashRegister.current();

            const report = await Report.create({
                type: 'shift_report',
                startTime: startTime,
                endTime: `${moment().format('YYYY-MM-DD HH:mm:ss')}`,
                cashRegisterId: curCashRegister.id,
                filterOrders: {
                    cashRegisterId: curCashRegister.id,
                }
            });

            const receiptPrinter = this.$printService.getAssignedPrinter('receipt');
            const useReceiptPrinter = !!receiptPrinter && this.device.platform !== 'web';
            const text = useReceiptPrinter ? report.getPrintable().toText(receiptPrinter.charsPerLine).join('\n') : null;

            this.$printService.printCustom(text, report.getPrintable().toHtml('report').join(''), null, { choosePrinter: !useReceiptPrinter })
        },

        showUserDeposit(user) {
            this.depositUser = user
            this.show.deposit = true
        },

        async updateUserDeposit(value) {
            this.busy = true;

            const result = await this.depositUser.addDeposit(value);

            this.busy = false;

            if(!result.success) {
                this.$snackbar(this.$t('staff.user_deposit_add_error'), 'error');
                return;
            }

            this.$snackbar(this.$t('staff.user_deposit_added'), 'success');
            this.show.deposit = false;
        },

        async addCashRegisterDeposit(value) {
            if(!this.curShift || value < 0 || (locale !== 'me' && value == 0)) {
                return
            }

            this.busy = true;

            const result = await this.curCashRegister.addTransaction(value);

            this.busy = false;

            if(!result.success) {
                this.$snackbar(this.$t('general.cash_register_add_deposit_error'), 'error');
                return;
            }

            this.show.cashRegisterDeposit = false;
            this.$snackbar(this.$t('general.cash_register_add_deposit_success'), 'success');
        },

        async addCashRegisterTransaction(value) {
            if(!this.curShift || value == 0) {
                return
            }

            if(this.curCashRegister.depositRequired()) {
                this.show.shift = false;
                this.show.cashRegisterDeposit = true;
                return;
            }

            this.busy = true;

            const result = await this.curCashRegister.addTransaction(value);

            this.busy = false;

            if(!result.success) {
                this.$snackbar(this.$t('general.cash_out_error'), 'error');
                return;
            }

            this.show.cashRegisterCashOut = false;
            this.$snackbar(this.$t('general.cash_out_success'), 'success');
        },

        reloadApp() {
            if(!this.isOnline) {
                this.$snackbar(this.$t('connection.internet_offline_message_not_allowed'), 'error');
                return
            }

            location.reload()
        },

        async checkNotifications() {
            await Notification.fetchUnread()
            const unreadNotifications = Notification.unread()
            if(unreadNotifications.length) {
                this.eventBus.$emit('show-notification', { notification: unreadNotifications[0] });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.order-navigation-drawer {
    .drawer-content {
        background: white;
        height: 100%;
        border-right: 1px solid #c7cbd6;
        position: relative;

        .expand-btn {
            position: absolute;
            right: 22px;
            top: 10px;
        }

        .menu-list {
            height: 100%;
            display: flex;
            flex-direction: column;

            .menu-item-additional {
                flex: 1;
                display: flex;
                align-items: flex-end;
            }

            .menu-item {
                .menu-icon {
                    width: 30px;
                    display: flex;
                    justify-content: center;
                    margin-right: 0px;
                }
            }
        }
    }
}
</style>
